import { render, staticRenderFns } from "./greetings.vue?vue&type=template&id=28df8bbe&scoped=true&"
import script from "./greetings.vue?vue&type=script&lang=js&"
export * from "./greetings.vue?vue&type=script&lang=js&"
import style0 from "./greetings.vue?vue&type=style&index=0&id=28df8bbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df8bbe",
  null
  
)

export default component.exports